import {
    FETCH_TICKETS,
} from '../actions/ticket';


export const initialState = {
    isFetching: true,
    data: null
};


export const tickets = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_TICKETS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_TICKETS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/ticket.js